import _ from 'lodash'
import { inject } from 'vue'

export enum Theme {
  DARK = 'theme-dark',
  LIGHT = 'theme-light'
}

export const setTheme = (theme: Theme) => {
  const setThemeClass = inject('setThemeClass', _.noop)
  setThemeClass(theme)
}
